export enum eOrgchartOrientation {
  Top = 'top',
  Right = 'right',
  Left = 'left',
}
